import React, { useState, useEffect } from "react";
import './App.css';
import QRcard from "./components/QRcard";
import Form from "./components/Form";
import { nanoid } from 'nanoid';

function App(props) {
  const [linkList, setLinkList] = useState(props.links);
  const [linkName, setLinkName] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [listModified, setModified] = useState(false);

  function addLink(e) {
    e.preventDefault();
    if(linkName.trim()!=="" && linkUrl.trim()!== ""){
      const newLink = {
        "name": linkName,
        "url": linkUrl,
        "id": `QR-${nanoid()}`
      };

      setLinkList([...linkList,newLink]);
      setModified(true);
    }
    setLinkName("");
    setLinkUrl("");
  }

  function deleteLink(id){
    const filteredLinks = linkList.filter(link => id !== link.id);
    setLinkList(filteredLinks);
    setModified(true);
  }

  function linkNameChange(e){
    setLinkName(e.target.value);
  }

  function linkUrlChange(e){
    setLinkUrl(e.target.value);
  }

  const linkFarm = linkList.map(link => (
    <QRcard
      id={`${link.id}`}
      name={link.name}
      url={link.url}
      delete={deleteLink}
      key={`${link.id}`}
    />
  ));

  useEffect(() => {
    if(listModified){
      localStorage.setItem('linkList',JSON.stringify(linkList))
      setModified(false);
    }
  },[listModified,linkList])
  return (
    
  <div className="App">
    <div className="jumbotron text-center">
      <h1>QR Farm</h1>
      <p className="lead">Add some links</p>
      <p>created using <a href="https://qrtag.net">QRtag API</a></p>
      <p>
        <a className="btn-sm btn-outline-info" data-toggle="collapse" href="#collapseMessage" role="button" aria-expanded="false" aria-controls="collapseExample">
          Privacy Info
        </a>
        <div className="collapse" id="collapseMessage">
          <div>
            <p>Local storage is only used for storing link information. Nothing is stored on the server but of course always use care with what information you decide to use with the app! </p>
          </div>
        </div>
      </p>

      <Form 
        linkName={linkName}
        linkNameChange={linkNameChange}
        linkUrl={linkUrl}
        linkUrlChange={linkUrlChange}
        addLink={addLink}
      />
    </div>

    <div className="QRlist container-fluid">
      <div className="d-flex justify-content-around flex-wrap">
        {linkFarm}
      </div>
    </div>
  </div>
  );
}

export default App;